module.exports = __webpack_public_path__ + "static/media/plane.f96dce57.svg";